// extracted by mini-css-extract-plugin
export default {"backdrop":"backdrop-87b07","modal":"modal-87b07","shine":"shine-87b07"};